import { List } from "../Components/index.js";

export default [
    {
        path: "/admin/fd/setting/group",
        component: List,
        name: "fd.setting.group",
        meta: {
            requiresAuth: true,
        },
    },
];
